<template>
  <div class="view pa24">
    <div class="d-flex">
      <div>
        <el-input class="w220 mr10" :placeholder="$t('merchandise', 'pleaseEnterTemplateName')" />
        <el-button type="primary" plain>{{ $t('merchandise', 'search') }}</el-button>
      </div>
      <el-button style="margin-left: auto" type="primary"
        >{{ $t('merchandise', 'createNewTemplate') }}</el-button
      >
    </div>
    <commonTable :tableData="tableData">
      <template v-slot:table>
        <el-table-column prop="templateName" align="center" :label="$t('merchandise', 'templateName')" />
        <el-table-column prop="updateTime" align="center" :label="$t('merchandise', 'updateTime')" />
        <el-table-column
          prop="relatedGoods"
          align="center"
          :label="$t('merchandise', 'relatedGoods')"
          show-overflow-tooltip
        />
        <el-table-column align="center" :label="$t('merchandise', 'operation')">
          <template>
            <el-button type="text">{{ $t('merchandise', 'detail') }}</el-button>
          </template>
        </el-table-column>
      </template>
    </commonTable>
  </div>
</template>

<script>
// @ts-ignore
import commonTable from "@/components/common/commonTable";
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: "freightManagement",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      tableData: [
        {
          templateName: this.$t('merchandise', 'freeShipping'),
          updateTime: "2019-09-24  12:06:33",
          relatedGoods: "10",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>